/** روابط المتاجر الرسمية لطازج للذبائح واللحوم — تُستخدم في المدونة وschema.org sameAs. */
export const TAZEJ_PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.intixdwc.adc.customer";
export const TAZEJ_APP_STORE_URL =
    "https://apps.apple.com/sa/app/tazej-%D8%B7%D8%A7%D8%B2%D8%AC/id1150041871";

/** ملفات اجتماعية رسمية ظاهرة في واجهة الحساب — لـ Organization.sameAs */
export const TAZEJ_INSTAGRAM_URL = "https://www.instagram.com/tazejfood/";
export const TAZEJ_TIKTOK_URL = "https://www.tiktok.com/@tazejfood";
export const TAZEJ_X_URL = "https://x.com/tazejfood";

/** روابط كيان العلامة لمحركات البحث والإجابة الذكية */
export const ORGANIZATION_SAME_AS = [
    TAZEJ_APP_STORE_URL,
    TAZEJ_PLAY_STORE_URL,
    TAZEJ_INSTAGRAM_URL,
    TAZEJ_TIKTOK_URL,
    TAZEJ_X_URL,
];
